var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    class: _vm.$style.ActionBlock,
    on: {
      "mouseenter": _vm.handleMouseEnter,
      "mouseleave": _vm.handleMouseLeave,
      "click": function click($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('div', {
    class: _vm.$style.container
  }, [_vm._t("default"), _vm._v(" "), _vm._t("button", null, {
    "hovered": _vm.isHovered
  })], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };